import React from "react";
import "./TeamMember.css";

function TeamMember({ Name, Title, Image, Github, LinkedIn }) {
  return (
    <div className="col-sm-6 col-md-4 col-lg-3 mb-5 text-center">
      <div className="team-card">
        <img src={Image} className="team-img mb-3" alt={Name} />
        <h5 className="fw-bold">{Name}</h5>
        <p className="text-muted">{Title}</p>
        <p className="social-links">
          <a href={Github} target="_blank" rel="noreferrer">Website</a> |{" "}
          <a href={LinkedIn} target="_blank" rel="noreferrer">LinkedIn</a>
        </p>
      </div>
    </div>
  );
}

export default TeamMember;
